import React, { useState } from 'react';
import TimePicker from 'react-time-picker';
import PropTypes from 'prop-types';

const TIME_PICKER_FORMAT = 'HH:mm';

const propTypes = {
  onTimeChange: PropTypes.func.isRequired,
  selectedTime: PropTypes.string,
  style: PropTypes.string,
  format: PropTypes.string
};
const defaultProps = {
  selectedTime: '',
  style: '',
  format: TIME_PICKER_FORMAT
};

const TimeSelector = ({
  onTimeChange, selectedTime, style, format
}) => {
  // TODO: Rework the TimePicker ASAP
  // Handling state is wrong here, coz timpicker internally handled with state
  // Not Stable
  const [time] = useState(selectedTime);
  const maxDetail = TIME_PICKER_FORMAT === format ? 'minute' : 'second';

  return (
    <TimePicker
      className={style}
      onChange={(t) => t !== null && onTimeChange(t)}
      maxDetail={maxDetail}
      value={time}
      hourPlaceholder="hh"
      minutePlaceholder="mm"
      secondPlaceholder="ss"
      disableClock
      format={format}
      clearIcon={null}
    />
  );
};

export default TimeSelector;
TimeSelector.propTypes = propTypes;
TimeSelector.defaultProps = defaultProps;
